import usePosts from "../hooks/usePosts";

export default function PostsScreen() {

  const { posts, loading } =
    usePosts();

  return (
    <div className="min-h-screen p-10">

      {/* HI TEXT */}
      <h1
        className="
          text-5xl
          font-bold
          text-center
          mb-10
        "
      >
        Hi
      </h1>

      {/* LOADING */}
      {loading && (
        <p className="text-center">
          Loading...
        </p>
      )}

      {/* POSTS */}
      <div className="space-y-6">

        {posts.map((post) => (

          <div
            key={post.id}
            className="
              border
              rounded-xl
              p-5
              shadow-md
            "
          >
            <h2
              className="
                text-xl
                font-semibold
                mb-2
              "
            >
              {post.title}
            </h2>

            <p>
              {post.body}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
